<template>
	<div>
		<timed-content
			:from="annualSalesPhases[0].from"
			:to="annualSalesPhases[0].to"
			:timezone="timeZone"
			@show="startPhase1"
			@hide="remove"
		>
			<slot :phasesInfo="{ currentPhase, annualSalesPhases, timeZone }" />
		</timed-content>
		<!-- <timed-content
			:from="annualSalesPhases[1].from"
			:to="annualSalesPhases[1].to"
			:timezone="timeZone"
			@show="startPhase2"
			@hide="remove"
		>
			<slot :phasesInfo="{ currentPhase, annualSalesPhases, timeZone }" />
		</timed-content> -->
		<slot name="originalContent" v-if="showOriginalContent"/>
	</div>
</template>

<script>
import TimedContent from "vue-timed-content";
import { PROMO_SALES } from "@/config/constants";

export default {
	name: "PromoSalesTimed",
	components: {
		TimedContent
	},
	data() {
		return {
			currentPhase: 0,
			showOriginalContent: true,
			timeZone: PROMO_SALES.TIME_ZONE,
			annualSalesPhases: PROMO_SALES.PHASES
		};
	},
	methods: {
		startPhase1() {
			this.currentPhase = 0;
			this.showOriginalContent = false;
			$("body").addClass("zd-widget-move-step5-holiday");
		},
		// startPhase2() {
		// 	this.currentPhase = 1;
		// 	this.showOriginalContent = false;
		// 	$("body").addClass("zd-widget-move-step5-holiday");
		// },
		remove() {
			this.currentPhase = -1;
			this.showOriginalContent = true;
			$("body").removeClass("zd-widget-move-step5-holiday");
		}
	}
};
</script>